import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

export const IconGridEmpty: FC<PropsWithClassName> = ({ className }) => {
    const size = 39;
    const spacing = 10;
    const strokeWidth = 2;
    const offset = strokeWidth / 2;
    const nextStart = offset + size + spacing;
    return (
        <svg
            className={className}
            width="90"
            height="90"
            viewBox="0 0 90 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {[
                { x: offset, y: offset },
                { x: nextStart, y: offset },
                { x: offset, y: nextStart },
                { x: nextStart, y: nextStart },
            ].map(({ x, y }) => {
                return (
                    <rect
                        key={`${x}-${y}`}
                        stroke="currentColor"
                        strokeWidth={strokeWidth}
                        // Very deliberate values to ensure that the corners are stroked.
                        // If you change the size these will need to be updated. The underlying math escapes me presently.
                        strokeDasharray={"7 6"}
                        strokeDashoffset={"-9.5px"}
                        fill="none"
                        x={x}
                        y={y}
                        width={size}
                        height={size}
                    />
                );
            })}
        </svg>
    );
};
